import React from "react";
import "../features/components/nav/style.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ComingSoon = () => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <p className="coming-soon text-center">{t("page_not_found")}</p>
      <Link
        to="/"
        type="button"
        class="btn btn-outline-secondary p-lg-3 btn-sm"
      >{t("go_back")}</Link>
    </div>
  );
};

export default ComingSoon;
